"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Spinner = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _constants = require("../../constants");
var _identifier = require("../../util/identifier");
var _Icon = require("../Icon/Icon");
var _Spinner = require("./Spinner.styles");
var _excluded = ["children"];
/**
 * A visual indicator that something is loading, submitting, precessing, etc.
 *
 * You should include this in a container with `aria-role="status"` and supporting text to help
 * assistive technologies announce what is happening; the `LoadingMask` and `LoadingButton`
 * components do this for you.
 *
 * @related ['Combobox', 'LoadingButton', 'LoadingMask']
 * @since 8.1.0
 */
var Spinner = (0, _Icon.withIcon)( /*#__PURE__*/(0, _react.forwardRef)(function (_ref, forwardedRef) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var _useRef = (0, _react.useRef)((0, _identifier.identifier)()),
    id = _useRef.current;
  return /*#__PURE__*/_react.default.createElement(_Spinner.StyledSpinner, (0, _extends2.default)({
    ref: forwardedRef,
    viewBox: "0 0 10 10"
  }, rest), children, /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: id + "_a",
    x1: ".5",
    y1: "0",
    x2: "0",
    y2: ".5"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "currentColor",
    stopOpacity: "1"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "currentColor",
    stopOpacity: ".75",
    offset: "1"
  })), /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: id + "_b",
    x1: "0",
    y1: ".5",
    x2: ".5",
    y2: "1"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "currentColor",
    stopOpacity: ".75"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "currentColor",
    stopOpacity: ".5",
    offset: "1"
  })), /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: id + "_c",
    x1: ".5",
    y1: "1",
    x2: "1",
    y2: ".5"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "currentColor",
    stopOpacity: ".5"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "currentColor",
    stopOpacity: ".25",
    offset: "1"
  })), /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: id + "_d",
    x1: "1",
    y1: ".5",
    x2: "0",
    y2: "0"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "currentColor",
    stopOpacity: ".25"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "currentColor",
    stopOpacity: "0",
    offset: "1"
  }))), /*#__PURE__*/_react.default.createElement("g", {
    fill: "none",
    strokeWidth: "1.5"
  }, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "url(#" + id + "_a)",
    d: "M 5 1 A 4 4 0 0 0 1 5"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: "url(#" + id + "_b)",
    d: "M 1 5 A 4 4 0 0 0 5 9"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: "url(#" + id + "_c)",
    d: "M 5 9 A 4 4 0 0 0 9 5"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: "url(#" + id + "_d)",
    d: "M 9 5 A 4 4 0 0 0 7 1.536"
  })), /*#__PURE__*/_react.default.createElement("circle", {
    fill: "currentColor",
    cx: "5",
    cy: "1",
    r: ".25"
  }));
}));
exports.Spinner = Spinner;
Spinner.displayName = 'Spinner';
Spinner.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node,
  /** @ignore */
  fontColor: _propTypes.default.string,
  /** The spinner size. By default this will match the font-size of the container. */
  size: _propTypes.default.oneOf(Object.values(_constants.ICON_SIZES))
} : {};
Spinner.defaultProps = {
  children: /*#__PURE__*/_react.default.createElement("title", null, "Loading"),
  fontColor: 'brand',
  size: undefined
};